import React from 'react';

function SensorGas() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_241_1093)">
        <path
          d="M73.132 57.196C73.648 53.952 74 47.47 74 39.994C74 32.518 73.646 25.99 73.126 22.76C71.948 14.53 65.432 8.028 57.196 6.868C53.952 6.352 47.47 6 39.994 6C32.518 6 25.992 6.354 22.76 6.874C14.53 8.052 8.028 14.568 6.868 22.804C6.352 26.048 6 32.53 6 40.006C6 47.482 6.354 54.01 6.874 57.24C8.052 65.47 14.568 71.972 22.804 73.132C26.048 73.648 32.53 74 40.006 74C47.482 74 54.01 73.646 57.24 73.126C65.47 71.948 71.972 65.432 73.132 57.196Z"
          fill="#F7F4F1"
        />
        <path
          d="M68.3984 54.7399C68.8404 51.9599 69.1424 46.4019 69.1424 39.9959C69.1424 33.5899 68.8384 27.9939 68.3944 25.2239C67.3844 18.1699 61.7984 12.5959 54.7404 11.6019C51.9604 11.1599 46.4024 10.8579 39.9964 10.8579C33.5904 10.8579 27.9944 11.1619 25.2244 11.6059C18.1704 12.6159 12.5964 18.2019 11.6024 25.2599C11.1604 28.0399 10.8584 33.5979 10.8584 40.0039C10.8584 46.4099 11.1624 52.0059 11.6064 54.7759C12.6164 61.8299 18.2024 67.4039 25.2604 68.3979C28.0404 68.8399 33.5984 69.1419 40.0044 69.1419C46.4104 69.1419 52.0064 68.8379 54.7764 68.3939C61.8304 67.3839 67.4044 61.7979 68.3984 54.7399Z"
          fill="white"
        />
        <path
          d="M73.9182 22.6479C72.6942 14.0959 65.8642 7.2819 57.3222 6.0799C53.9162 5.5379 47.2782 5.2019 39.9962 5.2019C32.7142 5.2019 26.0302 5.5399 22.6482 6.0839C14.0962 7.3079 7.28215 14.1379 6.08015 22.6799C5.53815 26.0839 5.20215 32.7219 5.20215 40.0059C5.20215 47.2899 5.54015 53.9739 6.08415 57.3539C7.30815 65.9059 14.1382 72.7199 22.6802 73.9239C26.0862 74.4659 32.7242 74.8019 40.0062 74.8019C47.2882 74.8019 53.9722 74.4639 57.3542 73.9199C65.9042 72.6959 72.7162 65.8679 73.9242 57.3179C74.4662 53.9119 74.8022 47.2759 74.8022 39.9979C74.8022 32.7199 74.4642 26.0299 73.9202 22.6499L73.9182 22.6479ZM72.3422 57.0719C72.3422 57.0719 72.3422 57.0819 72.3402 57.0859C71.2342 64.9399 64.9782 71.2099 57.1142 72.3379C53.7962 72.8699 47.2422 73.2019 40.0062 73.2019C32.7702 73.2019 26.2582 72.8739 22.9162 72.3419C15.0622 71.2359 8.79015 64.9799 7.66415 57.1139C7.13215 53.7979 6.80015 47.2419 6.80015 40.0059C6.80015 32.7699 7.12815 26.2579 7.66015 22.9159C8.76615 15.0619 15.0222 8.79191 22.8862 7.6639C26.2042 7.1319 32.7602 6.7999 39.9942 6.7999C47.2282 6.7999 53.7422 7.1279 57.0842 7.6599C64.9382 8.76591 71.2102 15.0219 72.3362 22.8879C72.8682 26.2039 73.2002 32.7599 73.2002 39.9959C73.2002 47.2319 72.8722 53.7439 72.3422 57.0719Z"
          fill="#84827E"
        />
        <path
          d="M54.8666 10.8119C51.9426 10.3459 46.2446 10.0579 39.9966 10.0579C33.7486 10.0579 28.0126 10.3479 25.1106 10.8139C17.7306 11.8699 11.8506 17.7659 10.8126 25.1339C10.3466 28.0559 10.0586 33.7539 10.0586 40.0039C10.0586 46.2539 10.3486 51.9879 10.8146 54.8899C11.8706 62.2699 17.7666 68.1499 25.1346 69.1879C28.0586 69.6539 33.7566 69.9419 40.0046 69.9419C46.2526 69.9419 51.9886 69.6519 54.8906 69.1859C62.2686 68.1299 68.1486 62.2379 69.1906 54.8579C69.6546 51.9319 69.9426 46.2379 69.9426 39.9959C69.9426 33.7539 69.6526 28.0119 69.1866 25.1099C68.1306 17.7299 62.2346 11.8499 54.8666 10.8119ZM67.6106 54.6139C67.6106 54.6139 67.6106 54.6239 67.6086 54.6279C66.6666 61.3099 61.3446 66.6459 54.6526 67.6039C51.8146 68.0599 46.2026 68.3419 40.0066 68.3419C33.8106 68.3419 28.2346 68.0599 25.3746 67.6059C18.6926 66.6639 13.3566 61.3419 12.3986 54.6499C11.9426 51.8119 11.6606 46.1999 11.6606 40.0039C11.6606 33.8079 11.9426 28.2319 12.3966 25.3719C13.3386 18.6899 18.6606 13.3539 25.3526 12.3959C28.1906 11.9399 33.8026 11.6579 39.9986 11.6579C46.1946 11.6579 51.7706 11.9399 54.6306 12.3939C61.3126 13.3359 66.6486 18.6579 67.6066 25.3499C68.0626 28.1879 68.3446 33.7999 68.3446 39.9959C68.3446 46.1919 68.0626 51.7679 67.6106 54.6139Z"
          fill="#84827E"
        />
        <path
          d="M42.4006 21.5719C42.4006 20.2464 41.3261 19.1719 40.0006 19.1719C38.6751 19.1719 37.6006 20.2464 37.6006 21.5719V26.3719C37.6006 27.6974 38.6751 28.7719 40.0006 28.7719C41.3261 28.7719 42.4006 27.6974 42.4006 26.3719V21.5719Z"
          fill="url(#paint0_linear_241_1093)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_241_1093"
          x="3.80215"
          y="3.8019"
          width="75.5996"
          height="75.6001"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.6" dy="1.6" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_241_1093"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_241_1093"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_241_1093"
          x1="38.2757"
          y1="20.0305"
          x2="43.9534"
          y2="23.2869"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SensorGas;
